const svgs = import.meta.glob('@/assets/svg/cryptos/*.svg', {
  eager: true,
  import: 'default'
})

export const cryptoIcons = Object.fromEntries(
  Object.entries(svgs).map(([path, mod]) => {
    const name = path.split('/').pop()!.replace('.svg', '').toUpperCase()
    return [name, mod]
  })
)
